<div>
  <div class="row mb-4">
    <div class="col-lg-9 col-md-8">
      <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
        As per the information provided, the owner(s) of the Company and/or the Company itself owns the building and
        real estate from which it operates. Therefore, a rent adjustment must be made.
        <div class="mt-3">Please provide the current rent expense and fair market rent
          information for each location below.</div>
      </div>
    </div>
    <div class="col-lg-3 col-md-4">
      <button class="button secondary__button large__button half-rounded__button" id="rent-details-edit-locations"
        (click)="gotoLocation()">
        Edit Locations
      </button>
    </div>
  </div>

  <div class="mb-5">

    <div class="row mb-4">
      <div class="col-md-12" *ngIf="currentReport && currentReport.LATEST">
        <ng-container *ngFor="let location of locationList; let i = index">
          <ng-container *ngIf="locationList.length > 1">
            <button class="button small__button half-rounded__button mb-1 mr-2" [disabled]="currentReport?.isLocked"
              [ngClass]="{'primary__button': selectedLocation && location.ID == selectedLocation.ID}"
              [class.secondary__button]="selectedLocation && location.ID != selectedLocation.ID"
              (click)="selectLocation(location)" id="{{'rent-details-selected-location-'+i}}">
              {{reportService.checkStringWithTrim(location.DISPLAY_NAME) ? location.DISPLAY_NAME : location.NAME}}
            </button>
          </ng-container>
          <ng-container *ngIf="locationList.length == 1">
            <div class="font-size-21 font-weight-bold mb-1 mr-2" id="{{'rent-details-selected-location-'+i}}">
              {{reportService.checkStringWithTrim(location.DISPLAY_NAME) ? location.DISPLAY_NAME : location.NAME}}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <form #rentForm="ngForm" novalidate="novalidate" autocomplete="off">

      <ng-container *ngIf="selectedLocation && selectedLocation.ID">

        <ng-container
          *ngIf="(selectedLocation.IS_OWNED && !selectedLocation.IS_OWNED_ON_BS) || (!selectedLocation.IS_OWNED && selectedLocation.IS_RENT_INCREASE)">

          <ng-container *ngIf="!selectedLocation.RENT_EXPENSE_EACH_YEAR">
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="label">What is the current rent expense for each year (including all Gross Expenses such
                    as CAM, Insurance and Real Estate Taxes)?</div>
                  <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                </div>

                <number-input [(ngModel)]="selectedLocation.RENT_EXPENSE" [classes]="'input input__large input__blue'"
                  #RENT_EXPENSE="ngModel" [required]="true" [disabled]="currentReport?.isLocked" name="RENT_EXPENSE"
                  (blur)="callUpdateAPI('RENT_EXPENSE')" [allowZero]="true" [clearZero]="false" [allowNegative]="true"
                  id="RENT_EXPENSE"></number-input>

              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="selectedLocation.RENT_EXPENSE_EACH_YEAR">
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="label">What is the current rent expense for each year (including all Gross Expenses such
                    as
                    CAM,
                    Insurance and Real Estate Taxes)?</div>
                  <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                </div>
              </div>
            </div>
            <div class="row mb-3 position-relative"
              *ngFor="let ray of selectedLocation.RENT_ADJUSTMENT_YEARLY; let j = index">
              <div class="col-md-12">
                <div class="year">{{ray.INCOME_STATEMENT.YEAR}}</div>

                <ng-container *ngIf="ray.INCOME_STATEMENT.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                  <number-input [(ngModel)]="ray.VALUE" [classes]="'input input__large input__blue'" #RAY_VALUE="ngModel"
                    [required]="true" [disabled]="currentReport?.isLocked" name="RAY_VALUE_{{j}}"
                    (blur)="callUpdateRentAdjustmentYearlyAPI(ray);" [allowZero]="true" [clearZero]="false"
                    [allowNegative]="true" id="RAY_VALUE_{{j}}"></number-input>
                </ng-container>

                <ng-container *ngIf="ray.INCOME_STATEMENT.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                    <input type="text" id="RAY_VALUE_NA_{{j}}"
                        class="input input__large input__blue" disabled [value]="'0'">
                </ng-container>

              </div>
            </div>
          </ng-container>

          <div class="row mt-3">
            <div class="col-md-12">
              <label class="checkbox large">
                <input class="checkbox__input" type='checkbox' name="isRentExpensc" id="isRentExpensc" [value]="true"
                  [checked]="selectedLocation.RENT_EXPENSE_EACH_YEAR" [disabled]="currentReport?.isLocked"
                  (change)="selectedLocation.RENT_EXPENSE_EACH_YEAR = !selectedLocation.RENT_EXPENSE_EACH_YEAR; callUpdateAPI('RENT_EXPENSE_EACH_YEAR')" />
                <div class="checkbox__data pl-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text">I want to adjust rent manually for each year<br />
                    <span class="font-size-14 font-weight-normal">
                      By default – the system assumes a consistent rent for all years
                    </span>
                  </p>
                </div>
              </label>
            </div>
          </div>

        </ng-container>

        <hr class="my-3"
          *ngIf="(selectedLocation.IS_OWNED && !selectedLocation.IS_OWNED_ON_BS) || (!selectedLocation.IS_OWNED && selectedLocation.IS_RENT_INCREASE)">

        <div class="row my-5">
          <div class="col-md-12">
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">What is the annual fair market rent for {{reportService.checkStringWithTrim(selectedLocation.DISPLAY_NAME) ? selectedLocation.DISPLAY_NAME : selectedLocation.NAME}} (including all Gross
                Expenses) in {{mostRecentYear}}?</div>
              <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
            </div>
            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
              Please enter the fair market rent that a hypothetical buyer would be required to pay for this facility or
              a similar location.
            </div>

            <div class="checkbox__wrapper" *ngIf="isShow"
              [ngClass]="{'input__error': (MARKET_RENT.errors && (MARKET_RENT.dirty || MARKET_RENT.touched))}">

              <number-input [(ngModel)]="selectedLocation.MARKET_RENT" [classes]="'input input__large input__blue'"
                #MARKET_RENT="ngModel" [required]="true" name="MARKET_RENT"
                [disabled]="selectedLocation.AUTO_CALCULATED || currentReport?.isLocked"
                (blur)="callUpdateAPI('MARKET_RENT')" [allowZero]="true" [clearZero]="false" id="MARKET_RENT">
              </number-input>

              <div class="checkbox__wrap">
                <label class="checkbox large">
                  <input class="checkbox__input" type='checkbox' name="inlineFormCheck" id="inlineFormCheck"
                    [value]="true" [checked]="selectedLocation.AUTO_CALCULATED" [disabled]="currentReport?.isLocked"
                    (change)="selectedLocation.AUTO_CALCULATED = !selectedLocation.AUTO_CALCULATED; callUpdateAPI('AUTO_CALCULATED')" />
                  <div class="checkbox__data">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">Calculate for me</p>
                  </div>
                </label>
              </div>
            </div>

            <div class="color-secondary-gray font-size-14 font-weight-normal my-3">
              For assistance in finding a fair market rent amount, please visit <a id="rent-details-market-rent-link"
                href="http://loopnet.com" target="_blank" rel="noopener">www.loopnet.com</a> or click on "Calculate for me".
            </div>

          </div>
        </div>

        <ng-container *ngIf="selectedLocation.AUTO_CALCULATED">

          <div class="row mb-5">
            <div class="col-md-12 mb-2" id="autoCalcDiv">

              <input type="text" [(ngModel)]="selectedLocation.RENT_CALCULATION_TYPE" #RENT_CALCULATION_TYPE="ngModel"
                [disabled]="currentReport?.isLocked" style="display: none;" name="RENT_CALCULATION_TYPE" required>

              <!-- I know the square footage of the building -->
              <div class="rent-type-list" *ngIf="selectedLocation.ZIP && selectedLocation.isSqfVisivle"
                [class.selected]="selectedLocation.RENT_CALCULATION_TYPE == rentTypeList[0].value"
                (click)="selectedLocation.RENT_CALCULATION_TYPE = rentTypeList[0].value; callUpdateAPI('RENT_CALCULATION_TYPE')">
                <div *ngIf="rentTypeList[0].title">
                  <div [innerHtml]="rentTypeList[0].title"></div>
                </div>
              </div>

              <!-- I know the square footage of the building and the fair market rental rate per square foot -->
              <div class="rent-type-list" *ngIf="selectedLocation.IS_OWNED"
                [class.selected]="selectedLocation.RENT_CALCULATION_TYPE == rentTypeList[1].value"
                (click)="selectedLocation.RENT_CALCULATION_TYPE = rentTypeList[1].value; callUpdateAPI('RENT_CALCULATION_TYPE')">
                <div *ngIf="rentTypeList[1].title">
                  <div [innerHtml]="rentTypeList[1].title"></div>
                </div>
              </div>

              <!-- I know the approximate value of the real estate -->
              <div class="rent-type-list" *ngIf="selectedLocation.IS_OWNED"
                [class.selected]="selectedLocation.RENT_CALCULATION_TYPE == rentTypeList[2].value"
                (click)="selectedLocation.RENT_CALCULATION_TYPE = rentTypeList[2].value; callUpdateAPI('RENT_CALCULATION_TYPE')">
                <div *ngIf="rentTypeList[2].title">
                  <div [innerHtml]="rentTypeList[2].title"></div>
                </div>
              </div>

              <!-- Buyer and Landlord have negotiated a new lease -->
              <div class="rent-type-list"
                [class.selected]="selectedLocation.RENT_CALCULATION_TYPE == rentTypeList[3].value"
                (click)="selectedLocation.RENT_CALCULATION_TYPE = rentTypeList[3].value; callUpdateAPI('RENT_CALCULATION_TYPE')">
                <div *ngIf="rentTypeList[3].title">
                  <div [innerHtml]="rentTypeList[3].title"></div>
                </div>
              </div>

            </div>
          </div>

          <!-- I know the square footage of the building -->
          <div class="row mb-4"
            *ngIf="(selectedLocation.RENT_CALCULATION_TYPE == rentTypesEnum.SQUARE_FOOTAGE && selectedLocation.ZIP && selectedLocation.isSqfVisivle) || selectedLocation.RENT_CALCULATION_TYPE == rentTypesEnum.SQUARE_FOOTAGE_AND_MARKET_RENT">
            <div class="col-md-12">
              <div class="label">What is the interior square footage of the building occupied by the business?</div>

              <number-input [(ngModel)]="selectedLocation.SQUARE_FOOTAGE" [classes]="'input input__large input__blue'"
                #SQUARE_FOOTAGE="ngModel" [required]="true" [disabled]="currentReport?.isLocked" name="SQUARE_FOOTAGE"
                (blur)="callUpdateAPI('SQUARE_FOOTAGE')" id="SQUARE_FOOTAGE"></number-input>

            </div>
          </div>

          <!-- I know the square footage of the building and the fair market rental rate per square foot -->
          <div class="row mb-4"
            *ngIf="selectedLocation.RENT_CALCULATION_TYPE == rentTypesEnum.SQUARE_FOOTAGE_AND_MARKET_RENT">
            <div class="col-md-12">
              <div class="label">What is the approximate fair market rent per square foot per year?</div>
              <div class="position-relative">

                <number-input [(ngModel)]="selectedLocation.FAIR_MARKET_SQFT"
                  [classes]="'input input__wrap--icon right input__large input__blue'" #FAIR_MARKET_SQFT="ngModel"
                  [required]="true" [disabled]="currentReport?.isLocked" name="FAIR_MARKET_SQFT"
                  (blur)="callUpdateAPI('FAIR_MARKET_SQFT')" id="FAIR_MARKET_SQFT"></number-input>

                <span class="input__icon input__icon--large right color-secondary-gray">$</span>
              </div>
            </div>
          </div>

          <!-- I know the approximate value of the real estate -->
          <ng-container *ngIf="selectedLocation.RENT_CALCULATION_TYPE == rentTypesEnum.APPROXIMATE_VALUE">
            <div class="row mb-4">
              <div class="col-md-12">
                <div class="label">What is the approximate value of the real estate?</div>

                <number-input [(ngModel)]="selectedLocation.APPROXIMATE_VALUE"
                  [classes]="'input input__large input__blue'" #APPROXIMATE_VALUE="ngModel" [required]="true"
                  [disabled]="currentReport?.isLocked" name="APPROXIMATE_VALUE"
                  (blur)="callUpdateAPI('APPROXIMATE_VALUE')" id="APPROXIMATE_VALUE"></number-input>

              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <div class="label">Does the company occupy 100% of the real estate?</div>
                <radio-group-button radioGroupButtonId="rent-details-estate-type-radio-group"
                  [disabled]="currentReport?.isLocked" [selectedOption]="selectedLocation.FULL_OCCUPATION"
                  [btnList]="fullOccupationList" [isButton]="true" #FULL_OCCUPATION="ngModel" name="FULL_OCCUPATION"
                  [(ngModel)]="selectedLocation.FULL_OCCUPATION" required
                  (optionChange)="selectedLocation.FULL_OCCUPATION = $event; callUpdateAPI('FULL_OCCUPATION')">
                </radio-group-button>
              </div>
            </div>

            <div class="row mb-4" *ngIf="selectedLocation.FULL_OCCUPATION == false">
              <div class="col-md-12">
                <div class="label">What percentage of the real estate does the company occupy?</div>
                <div class="position-relative">
                  <input type="text" numbersOnly id="rent-details-percentage-occupy"
                    [disabled]="currentReport?.isLocked" class="input input__large input__blue input__wrap--icon right"
                    maxlength="2" [(ngModel)]="selectedLocation.PERCENT_OCCUPATION" required name="PERCENT_OCCUPATION"
                    #PERCENT_OCCUPATION="ngModel"
                    (blur)="PERCENT_OCCUPATION.valid ? callUpdateAPI('PERCENT_OCCUPATION') : null" [range]="[1, 99]">
                  <span class="input__icon input__icon--large right color-secondary-gray">%</span>
                </div>
                <small
                  *ngIf="PERCENT_OCCUPATION.errors?.range && (PERCENT_OCCUPATION.dirty || PERCENT_OCCUPATION.touched)"
                  class="text-danger">
                  percentage from 1 to 99
                </small>
              </div>
            </div>

          </ng-container>

          <!-- Buyer and Landlord have negotiated a new lease -->
          <div class="row mb-4" *ngIf="selectedLocation.RENT_CALCULATION_TYPE == rentTypesEnum.LEASE_NEGOTIATED">
            <div class="col-md-12">
              <div class="label">What is the negotiated annual rent including all Gross Expenses?</div>

              <number-input [(ngModel)]="selectedLocation.NEGOTIATED_RENT" [classes]="'input input__large input__blue'"
                #NEGOTIATED_RENT="ngModel" [required]="true" [disabled]="currentReport?.isLocked" name="NEGOTIATED_RENT"
                (blur)="callUpdateAPI('NEGOTIATED_RENT')" id="NEGOTIATED_RENT"></number-input>

            </div>
          </div>

        </ng-container>

      </ng-container>

    </form>

  </div>
</div>
<report-footer [nextBtnEnable]="rentForm.valid || currentReport?.isLocked" (buttonClicked)="footerButtonClick($event)"
  [pageId]="reportPageConst.RENT">
</report-footer>
